export enum WizardItemSubtype {
	NORMAL = 'normal',
	TEXT = 'text',
	HEADER = 'header',
	LARGE = 'large',
	MEDIUM = 'medium',
	V_STACK = 'vstack',
	HTML = 'html',
}
